import {blue} from "@mui/material/colors";

export const tabLink = {
    presale: {
        name: "Presale",
        href: "/pre-sale",
        icon: "/images/profile_image/account_image/invest-icon.svg",
        blue_icon: "/images/profile_image/account_image/invest-icon.svg",
        mobile_name: "Presale",
    },

    my_portfolio: {
        name: "My Portfolios",
        href: "/my-portfolio/detailed-portfolio-analysis",
        icon: "/images/portfolioicon.svg",
        blue_icon: "/images/portfolioicon.svg",
        mobile_name: "Portfolios",
        icon_width: "18px",
    },
    portfolio_detail: {
        name: "Portfolio Detail",
        href: "/portfolio-analysis",
        icon: "/images/portfolioicon.svg",
        blue_icon: "/images/portfolioicon.svg",
        mobile_name: "Portfolio Detail",
        icon_width: "18px",
    },
    portfolio_audit: {
        name: "Audit Portfolio",
        href: "/audit-my-portfolio",
        icon: "/images/portfolioicon.svg",
        blue_icon: "/images/portfolio_tab.svg",
        mobile_name: "Portfolio",
        icon_width: "25px",
    },
    top_portfolio: {
        name: "All Portfolios",
        href: "/portfolio-gallery",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Top Portfolios",
        icon_width: "30px",
    },
    portfolio: {
        name: "Portfolio",
        href: "/portfolio",
        icon: "/images/portfolioicon.svg",
        blue_icon: "/images/portfolioicon.svg",
        mobile_name: "Portfolio",
        icon_width: "18px",
    },
    top_portfolios: {
        name: "Best Portfolios",
        href: "/top-portfolios",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Top Portfolios",
        icon_width: "30px",
    },
    add_portfolios: {
        name: "Add Portfolios",
        href: "/create-portfolio",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Add Portfolios",
        icon_width: "30px",
    },
    indices: {
        name: "Indices",
        href: "/indices",
        icon: "/images/sidemenu_image/index_gallery.svg",
        blue_icon: "/images/sidemenu_image/index_gallery.svg",
        mobile_name: "Indices",
        icon_width: "18px",
    },
    rewards: {
        name: "Rewards",
        href: "/reward-section",
        icon: "/images/sidemenu_image/index_gallery.svg",
        blue_icon: "/images/sidemenu_image/index_gallery.svg",
        mobile_name: "Rewards",
        icon_width: "18px",
    },
    screener: {
        name: "Crypto Screener",
        href: "/crypto-screener",
        icon: "/images/privacyicon.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Screener",
        icon_width: "18px",
    },
    crypto_prediction: {
        name: "Crypto Predictions",
        href: "/crypto-predictions",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Predictions",
    },
    subscription: {
        name: "My Subscriptions",
        href: "/subscriptions",
        icon: "/images/subscription_tab.svg",
        blue_icon: "/images/subscription_tab.svg",
        mobile_name: "Subscriptions",
    },
    my_subscription: {
        name: "My Subscription",
        href: "/my-subscriptions",
        icon: "/images/subscription_tab.svg",
        blue_icon: "/images/subscription_tab.svg",
        mobile_name: "My Subscriptions",
    },
    whitepaper: {
        name: "Whitepaper",
        href: "/whitepaper",
        icon: "/images/whitepaper.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Whitepaper",
    },
    crypto_watchlist: {
        name: "Crypto Watchlist",
        href: "/crypto-watchlist",
        icon: "images/sidemenu_image/watchtlist.svg",
        blue_icon: "images/sidemenu_image/watchtlist.svg",
        mobile_name: "Watchlist",
        icon_width: "18px",
    },
    ai_portfolios: {
        name: "AI Portfolios",
        href: "/custom-portfolio",
        icon: "/images/sidemenu_image/ai_portfolio.svg",
        blue_icon: "images/sidemenu_image/ai_portfolio.svg",
        mobile_name: "AI Portfolios",
        icon_width: "20px",
    },
    crypto_replacement: {
        name: "Replace Crypto",
        href: "/crypto-replacement",
        icon: "/images/search_tab.svg",
        blue_icon: "/images/search_tab.svg",
        mobile_name: "Replace Crypto",
        icon_width: "18px",
    },
    compare_portfolio: {
        name: "Compare Portfolio",
        href: "/portfolio-comparison",
        icon: "images/sidemenu_image/compare_portfolio.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Compare Portfolio",
    },

    portfolio_analysis: {
        name: "Portfolio Report",
        href: "/portfolio-analysis",
        icon: "images/portfolio_tab.svg",
        blue_icon: "images/portfolio_tab.svg",
        mobile_name: "Portfolio Report",
        icon_width: "20px",
    },
    // "influencer_ranking":{
    //     name: "Influencer Rankings",
    //     href: "/crypto-influencer-rankings",
    //     icon: "/images/home-new.svg",
    //     blue_icon: "/images/profile_tab.svg",
    //     mobile_name: "Influencer Rankings",
    // },
    influencer_ranking: {
        name: "Influencer Rankings",
        href: "/crypto-influencer-rankings",
        icon: "/images/sidemenu_image/influencer_ranking.svg",
        blue_icon: "/images/sidemenu_image/influencer_ranking.svg",
        active_icon: "/images/sidemenu_image/influencer_ranking_active.svg",
        mobile_name: "Influencer Rankings",
        icon_width: "18px",
    },
    my_alerts: {
        name: "My Free Alerts",
        icon: "/images/notification.svg",
        href: "/alerts",
        blue_icon: "/images/notification.svg",
        mobile_name: "My Free Alerts",
        icon_width: "25px",
    },
    influencer_ranking_prediction: {
        name: "Predictions",
        href: "/crypto-influencer-rankings/predictions",
        icon: "/images/search_tab.svg",
        blue_icon: "/images/search_tab.svg",
        mobile_name: "Predictions",
        icon_width: "18px",
    },
    predict_now: {
        name: "Predict Now",
        href: "/predict-now",
        icon: "/images/faqicon.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Predict Now",
        icon_width: "18px",
    },
    portfolio_faq: {
        name: "Portfolio FAQ",
        href: "/portfoliofaqs",
        icon: "/images/sidemenu_image/faq.svg",
        blue_icon: "/images/sidemenu_image/faq.svg",
        mobile_name: "Portfolio FAQ",
    },
    profile: {
        name: "My Profile",
        href: "/account",
        icon: "/images/profile_tab.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Profile",
    },

    reward_history: {
        name: "Farm $WISD",
        href: "/reward-section",
        icon: "/images/search_tab.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Farm $WISD",
    },
    index_portfolio: {
        name: "All Indices",
        href: "/indices/indexgallery",
        icon: "/images/sidemenu_image/indices.svg",
        blue_icon: "/images/sidemenu_image/indices.svg",
        mobile_name: "All Indices",
        // icon_width: "30px",
    },
    premium_alerts: {
        name: "Premium Alerts",
        icon: "/images/premium_tag.svg",
        href: "/premium-alerts",
        blue_icon: "/images/premium_tag.svg",
        mobile_name: "Premium Alerts",
        icon_width: "22px",
    },
    best_predictions: {
        name: "Best Predictions",
        icon: "/images/red-arrow-point.svg",
        href: "/crypto-predictions/best-predictions",
        blue_icon: "/images/red-arrow-point.svg",
        mobile_name: "Best Predictions",
        icon_width: "22px",
    },
    smart_picks: {
        name: "Smart Money Picks",
        href: "/crypto-screener/smart-money-picks",
        icon: "/images/privacyicon.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Smart Money Picks",
        icon_width: "18px",
    },
    hidden_gems: {
        name: "Hidden Gems",
        href: "/crypto-screener/hidden-gems",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Hidden Gems",
        icon_width: "30px",
    },
    breakout_stars: {
        name: "BreakOut Stars",
        href: "/crypto-screener/breakout-stars",
        icon: "/images/portfolioicon.svg",
        blue_icon: "/images/portfolio_tab.svg",
        mobile_name: "BreakOut Stars",
        icon_width: "25px",
    },
    add_portfolios: {
        name: "Create Portfolios",
        href: "/create-portfolio",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Create Portfolios",
        icon_width: "30px",
    },
    add_creator: {
        name: "Add Creator",
        href: "/add-creator",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Add Creator",
        icon_width: "30px",
    },
    approve_influencer: {
        name: "Influencer Approval",
        href: "/reward-section/approve-earn",
        icon: "/images/home-new.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Influencer Approval",
        icon_width: "30px",
    },
    whitepaper: {
        name: "Whitepaper",
        href: "/whitepaper.pdf",
        icon: "/images/whitepaper.svg",
        blue_icon: "/images/profile_tab.svg",
        mobile_name: "Whitepaper",
        external: true, 
        },
};
